//# sourceMappingURL=common.mjs.map
/// <reference types="./common.d.mts" />
import * as $l from "../../../../ds/ds/components/layout.mjs";
import * as $icons from "../../../../ds/ds/icons.mjs";
import * as $a from "../../../../redraw_dom/redraw/dom/attribute.mjs";
import * as $h from "../../../../redraw_dom/redraw/dom/html.mjs";
import { toList } from "../../../gleam.mjs";
import * as $common from "../../../view/common.mjs";

/**
 * Shared header between the versioning view and the translations view.
 * `title`: full title to display (with optional suffix).
 * `actions`: element displayed on the right (date, button, toggle…).
 */
export function proposal_title(title, actions) {
  return $l.row(
    toList([$l.align("center"), $l.justify("space-between")]),
    toList([]),
    toList([
      $l.row(
        toList([$l.align("center"), $l.justify("center"), $l.gap(12)]),
        toList([]),
        toList([
          $h.a(
            toList([$a.href("/proposal/versioning")]),
            toList([$icons.medium($icons.arrow_left_line())]),
          ),
          $common.page_title(title),
        ]),
      ),
      actions,
    ]),
  );
}

export function text(content) {
  return $h.div(toList([]), toList([$h.text(content)]));
}
